import { render, staticRenderFns } from "./msgReplyForm.vue?vue&type=template&id=460bcf9c&scoped=true"
import script from "./msgReplyForm.vue?vue&type=script&lang=js"
export * from "./msgReplyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460bcf9c",
  null
  
)

export default component.exports